import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import config from '../../config';
import Title from './title';

const CompanySettings = () => {
  const user = useSelector(state => state.user.currentUser);
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editingCompany, setEditingCompany] = useState(false);
  const [companyForm, setCompanyForm] = useState({
    phone: '',
    email: '',
    website: '',
    address: '',
    primaryColor: '#007bff',
    secondaryColor: '#6c757d'
  });
  const [logoFile, setLogoFile] = useState(null);
  const [uploadingLogo, setUploadingLogo] = useState(false);

  useEffect(() => {
    if (user?.role === 'company_admin') {
      loadCompanyData();
    }
  }, [user]);

  const loadCompanyData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${config.apiUrl}/api/company/my-company`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });

      setCompany(response.data.company);
      setLogoFile(null);
      setCompanyForm({
        phone: response.data.company.phone || '',
        email: response.data.company.email || '',
        website: response.data.company.website || '',
        address: response.data.company.address || '',
        primaryColor: response.data.company.primaryColor || '#007bff',
        secondaryColor: response.data.company.secondaryColor || '#6c757d'
      });
    } catch (error) {
      console.error('Ошибка загрузки данных компании:', error);
      alert('Ошибка загрузки данных компании');
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateCompany = async () => {
    try {
      await axios.put(`${config.apiUrl}/api/company/${company._id}`, companyForm, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });

      alert('Данные компании обновлены успешно!');
      setEditingCompany(false);
      loadCompanyData();
    } catch (error) {
      console.error('Ошибка обновления компании:', error);
      alert(error.response?.data?.message || 'Ошибка обновления компании');
    }
  };

  const handleLogoChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setLogoFile(event.target.files[0]);
    }
  };

  const handleUploadLogo = async () => {
    if (!logoFile) return;

    setUploadingLogo(true);

    const formData = new FormData();
    formData.append('logo', logoFile);

    try {
      const response = await axios.post(`${config.apiUrl}/api/upload/company-logo`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      setCompany(prev => ({ ...prev, logo: response.data.logoUrl }));
      setLogoFile(null);
      alert('Логотип успешно загружен');
    } catch (error) {
      console.error('Ошибка загрузки логотипа:', error);
      alert(error.response?.data?.message || 'Ошибка загрузки логотипа');
    } finally {
      setUploadingLogo(false);
    }
  };

  if (loading) {
    return <div className="dashboard-content">Загрузка...</div>;
  }

  if (!company) {
    return <div className="dashboard-content">Компания не найдена</div>;
  }

  return (
    <div className="dashboard-content">
      <Title title="Настройки компании" />

      <div className="company-section">
        <div className="section-header">
          <h2>Информация о компании</h2>
          <button
            className="btn-primary"
            onClick={() => setEditingCompany(!editingCompany)}
          >
            {editingCompany ? 'Отмена' : 'Редактировать'}
          </button>
        </div>

        {!editingCompany ? (
          <div className="company-info">
            <div className="info-grid">
              <div className="info-item">
                <label>Название:</label>
                <span>{company.companyName}</span>
              </div>
              <div className="info-item">
                <label>Логотип:</label>
                <div>
                  {company.logo ? (
                    <img
                      src={`${config.apiUrl}${company.logo}`}
                      alt="Логотип компании"
                      style={{ maxWidth: '100px', maxHeight: '60px', objectFit: 'contain' }}
                    />
                  ) : (
                    <span>Не установлен</span>
                  )}
                </div>
              </div>
              <div className="info-item">
                <label>Телефон:</label>
                <span>{company.phone || 'Не указан'}</span>
              </div>
              <div className="info-item">
                <label>Email:</label>
                <span>{company.email || 'Не указан'}</span>
              </div>
              <div className="info-item">
                <label>Website:</label>
                <span>{company.website || 'Не указан'}</span>
              </div>
              <div className="info-item">
                <label>Адрес:</label>
                <span>{company.address || 'Не указан'}</span>
              </div>
              <div className="info-item">
                <label>Основной цвет:</label>
                <div style={{
                  backgroundColor: company.primaryColor || '#007bff',
                  width: '30px',
                  height: '20px',
                  borderRadius: '3px'
                }}></div>
              </div>
              <div className="info-item">
                <label>Вторичный цвет:</label>
                <div style={{
                  backgroundColor: company.secondaryColor || '#6c757d',
                  width: '30px',
                  height: '20px',
                  borderRadius: '3px'
                }}></div>
              </div>
              <div className="info-item">
                <label>Статус:</label>
                <span className={company.isActive ? 'status-active' : 'status-inactive'}>
                  {company.isActive ? 'Активна' : 'Неактивна'}
                </span>
              </div>
            </div>
          </div>
        ) : (
          <div className="company-edit-form">
            <div className="form-grid">
              <div className="form-group">
                <label>Телефон:</label>
                <input
                  type="text"
                  value={companyForm.phone}
                  onChange={(e) => setCompanyForm({...companyForm, phone: e.target.value})}
                  placeholder="Введите телефон"
                />
              </div>
              <div className="form-group">
                <label>Email:</label>
                <input
                  type="email"
                  value={companyForm.email}
                  onChange={(e) => setCompanyForm({...companyForm, email: e.target.value})}
                  placeholder="Введите email"
                />
              </div>
              <div className="form-group">
                <label>Website:</label>
                <input
                  type="url"
                  value={companyForm.website}
                  onChange={(e) => setCompanyForm({...companyForm, website: e.target.value})}
                  placeholder="https://example.com"
                />
              </div>
              <div className="form-group">
                <label>Адрес:</label>
                <input
                  type="text"
                  value={companyForm.address}
                  onChange={(e) => setCompanyForm({...companyForm, address: e.target.value})}
                  placeholder="Введите адрес"
                />
              </div>
              <div className="form-group">
                <label>Логотип:</label>
                {company.logo && (
                  <div style={{ marginBottom: '8px' }}>
                    <img
                      src={`${config.apiUrl}${company.logo}`}
                      alt="Логотип компании"
                      style={{ maxWidth: '120px', maxHeight: '80px', objectFit: 'contain' }}
                    />
                  </div>
                )}
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleLogoChange}
                />
                <button
                  className="btn-secondary"
                  type="button"
                  onClick={handleUploadLogo}
                  disabled={!logoFile || uploadingLogo}
                  style={{ marginTop: '8px' }}
                >
                  {uploadingLogo ? 'Загрузка...' : 'Загрузить логотип'}
                </button>
              </div>
              <div className="form-group">
                <label>Основной цвет:</label>
                <input
                  type="color"
                  value={companyForm.primaryColor}
                  onChange={(e) => setCompanyForm({...companyForm, primaryColor: e.target.value})}
                />
              </div>
              <div className="form-group">
                <label>Вторичный цвет:</label>
                <input
                  type="color"
                  value={companyForm.secondaryColor}
                  onChange={(e) => setCompanyForm({...companyForm, secondaryColor: e.target.value})}
                />
              </div>
            </div>
            <div className="form-actions">
              <button className="btn-success" onClick={handleUpdateCompany}>
                Сохранить
              </button>
              <button className="btn-secondary" onClick={() => setEditingCompany(false)}>
                Отмена
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CompanySettings;